module.exports = __webpack_public_path__ + "img/facebook_logo.84e7b68d.svg";